import React, { useContext } from "react";
import "./Gallery.scss";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function BasicGallery() {
  const { isDark } = useContext(StyleContext);

  return (
    <section className={`section ${isDark ? "dark-mode" : ""}`} id="gallery">
      <div className="container">
        <Fade bottom duration={1000} distance="20px">
          <div className="gallery-header">
            <p className="typography-eyebrow mb-2">My Photos</p>
            <h2 className="section-title mb-3">Gallery</h2>
            <p className="section-subtitle mb-5">A glimpse into my world through images</p>
          </div>

          <div className="gallery-grid">
            {/* Hardcoded images */}
            <div className="gallery-item">
              <img
                src={process.env.PUBLIC_URL + "/images/pic1.png"}
                alt="Gallery image 1"
                className="gallery-image"
                onError={(e) => {
                  console.error("Failed to load image 1");
                  e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                }}
              />
            </div>
            <div className="gallery-item">
              <img
                src="/images/pic2.png"
                alt="Gallery image 2"
                className="gallery-image"
                onError={(e) => {
                  console.error("Failed to load image 2");
                  e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                }}
              />
            </div>
            <div className="gallery-item">
              <img
                src="/images/pic3.png"
                alt="Gallery image 3"
                className="gallery-image"
                onError={(e) => {
                  console.error("Failed to load image 3");
                  e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                }}
              />
            </div>
            <div className="gallery-item">
              <img
                src="/images/pic4.png"
                alt="Gallery image 4"
                className="gallery-image"
                onError={(e) => {
                  console.error("Failed to load image 4");
                  e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                }}
              />
            </div>
            <div className="gallery-item">
              <img
                src="/images/pic5.png"
                alt="Gallery image 5"
                className="gallery-image"
                onError={(e) => {
                  console.error("Failed to load image 5");
                  e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                }}
              />
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
